import axios from 'axios';
import {
  Chart,
  ArcElement, LineElement, PointElement,
  PieController, LineController,
  LinearScale, TimeScale,
  Legend, Tooltip, Filler
}  from 'chart.js';
import dayjs from 'dayjs';
import 'dayjs/locale/de.js';
import 'chartjs-adapter-dayjs-3'

Chart.register(
  ArcElement, LineElement, PointElement,
  PieController, LineController,
  LinearScale, TimeScale,
  Legend, Tooltip, Filler
);

var initContentDistribution = function (canvasId) {
  var config = {
    type: "pie",
    data: {
      datasets: [],
      labels: [],
    },
    options: {
      responsive: true,
      aspectRatio: 2,
      plugins: {
        legend: {
          position: "right",
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              return context.label;
            },
          },
        },
      },
    },
  };

  axios
    .get("/content/distribution")
    .then(function (response) {
      let data = response.data;
      let labels = [];
      let values = [];
      let total = 0;
      if (data) {
        const ctx = document.getElementById(canvasId);
        if ("aspectratio" in ctx.dataset) config.options.aspectRatio = ctx.dataset.aspectratio;
        data.forEach(function (entry) {
          labels.push(
            entry.type +
            ": " +
            entry.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          );
          values.push(entry.count);
          total += parseInt(entry.count, 10);
        });
        config.data.datasets = [
          {
            data: values,
            backgroundColor: [
              "hsl(205,100%, 21%)",
              "hsl(209, 50%, 35%)",
              "hsl(209, 36%, 47%)",
              "hsl(208, 40%, 60%)",
              "hsl(207, 55%, 72%)",
              "hsl(205, 97%, 85%)",
            ],
            label: "Pollux Content",
          },
        ];
        config.data.labels = labels;
        let totalSpan = document.getElementById(`${canvasId}-total`);
        totalSpan.appendChild(
          document.createTextNode(
            total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
        );
        let chartAlt = document.createDocumentFragment();
        let chartAltDl = document.createElement("dl");
        chartAlt.appendChild(chartAltDl);
        data.forEach(function (entry) {
          let entryDt = document.createElement("dt");
          let entryDd = document.createElement("dd");
          entryDt.textContent = entry.type;
          entryDd.textContent = entry.count;
          chartAltDl.appendChild(entryDt);
          chartAltDl.appendChild(entryDd);
        });
        document.getElementById(canvasId).appendChild(chartAlt);
        new Chart(ctx, config);
      } else {
        throw "Error";
      }
    })
    .catch(function (error) {
      console.error(error);
    });
};

const initMediaTypeCountsHistory = function (canvasId) {
  const ctx = document.getElementById(canvasId);
  if (!ctx) return null;
  axios
    .get("/admin/stats/mediatypecountshistory")
    .then(function (response) {
      if ("language" in ctx.dataset)  dayjs.locale(ctx.dataset.language);
      new Chart(ctx, {
        type: 'line',
        data: {
          datasets: response.data.datasets,
        },
        options: {
          aspectRatio: 1.5,
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'month'
              }
            },
            y: {
              stacked: true,
              ticks: {
                callback: function(value) {
                  // return formatted original number
                  return value.toLocaleString()
                }
              }
            }
          },
          plugins: { legend: { position: "bottom" } },
        }
      });
    })
    .catch(function (error) {
      console.log(error);
      console.error(error);
    });
};

window.addEventListener("load", function(){initContentDistribution("media-type-counts")});
window.addEventListener("load", function(){initMediaTypeCountsHistory("media-type-counts-history")});
